import React from "react"

import { DragSourceDataContext } from "shared/context/drag-and-drop/DragSourceDataContext"
import { PointerPositionContext } from "shared/context/drag-and-drop/PointerPositionContext"
import { useDnDContextState } from "shared/lib/drag-and-drop/useDnDContextState"
import { WithChildren } from "shared/types/WithChildren"

import { DndContext, DragOverlay, MeasuringStrategy } from "@dnd-kit/core"
import { snapCenterToCursor } from "@dnd-kit/modifiers"

import { ProjectPageDragGhost } from "../ui/project-page-drag-ghost/ProjectPageDragGhost"

export const ProjectPageDnDProvider = React.memo(
  ({ children }: WithChildren) => {
    const {
      activeDragSource,
      activeDropTarget,
      handleDragStart,
      handleDragMove,
      handleDragEnd,
      sensors,
      collisionDetection,
      dragSourceContext,
      modifiers,
      pointerPositionContext
    } = useDnDContextState({ modifiers: [snapCenterToCursor] })

    return (
      <DndContext
        autoScroll={{
          acceleration: 100,
          enabled: true,
          threshold: { x: 0.05, y: 0.05 }
        }}
        onDragStart={handleDragStart}
        onDragMove={handleDragMove}
        onDragEnd={handleDragEnd}
        sensors={sensors}
        collisionDetection={collisionDetection}
        measuring={{
          droppable: {
            strategy: MeasuringStrategy.Always
          }
        }}
      >
        <DragSourceDataContext.Provider value={dragSourceContext}>
          <PointerPositionContext.Provider value={pointerPositionContext}>
            {children}
            <DragOverlay dropAnimation={null} modifiers={modifiers}>
              {activeDragSource ? (
                <ProjectPageDragGhost
                  dragSource={activeDragSource}
                  error={activeDropTarget?.error}
                />
              ) : null}
            </DragOverlay>
          </PointerPositionContext.Provider>
        </DragSourceDataContext.Provider>
      </DndContext>
    )
  }
)

ProjectPageDnDProvider.displayName = "DnDProvider"
